import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */ import Image from 'next/image';
import * as FEAAS from '@sitecore-feaas/clientside/react';
import { nextConfigImages } from 'lib/next-config/plugins/images';
// Element implementations for Sitecore Component Builder can be overriden here
const FEAASScripts = ()=>{
    // we cannot use nextjs's logic for remotePatterns matching without extra dependencies
    // so we use a limited approach for now - which will be replaced once nextjs allows to fall back to unoptimized OOB
    const convertToRegex = (pattern)=>{
        return pattern.replace('.', '\\.').replace(/\*/g, '.*');
    };
    const shouldOptimize = (src)=>{
        if (src.startsWith('http')) {
            const url = new URL(src);
            const remotePatterns = nextConfigImages?.remotePatterns || [];
            return remotePatterns.some((pattern)=>pattern.protocol === url.protocol.slice(0, -1) && new RegExp('^' + convertToRegex(pattern.hostname) + '$').test(url.hostname));
        }
        return true;
    };
    // Register next Image to be used in Component Builder.
    // Nextjs image implementation will be used when img is rendered in component from Component Builder
    FEAAS.setElementImplementation('img', (attributes)=>{
        const { children, src, alt, ...imgAttributes } = attributes;
        return /*#__PURE__*/ _jsx(Image, {
            height: 1920,
            width: 1200,
            unoptimized: !shouldOptimize(src),
            src: src,
            alt: alt,
            ...imgAttributes
        });
    });
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
export default FEAASScripts;
